import { useQuery } from '@tanstack/react-query';
import { schoolService } from '../../../services';

export interface TeacherOption {
  value: string;
  label: string;
}

// API trả bản ghi school_users kèm `user`; lớp lưu teacherId là id của user.
export const toTeacherOptions = (records: any[] = []): TeacherOption[] => {
  const seen = new Set<string>();
  return records.flatMap((record) => {
    const value = record?.userId ?? record?.user?.id ?? record?.user?._id;
    const label = record?.user?.name;
    if (!value || !label || seen.has(value)) return [];
    seen.add(value);
    return [{ value: String(value), label }];
  });
};

/** Giáo viên đang hoạt động của một trường, dạng lựa chọn cho ô chọn giáo viên chủ nhiệm. */
export const useSchoolTeacherOptions = (schoolId?: string) =>
  useQuery({
    // Chung tiền tố 'school-teachers' để thêm/sửa giáo viên (invalidate theo tiền tố) làm mới luôn danh sách chọn.
    queryKey: ['school-teachers', schoolId, 'options'],
    queryFn: () => schoolService.getSchoolTeachers(schoolId!),
    select: (response) => toTeacherOptions(response?.data),
    enabled: !!schoolId,
    staleTime: 5 * 60 * 1000,
  });
